import React from "react";
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import RedditIcon from "@mui/icons-material/Reddit";
import WebIcon from "@mui/icons-material/Web";
import generalUtil from "../../../utils/generalUtils";
import { Link } from "gatsby";

const ArticleAuthorCard = ({ articleAuthors }) => {

  const regexFaceBook = /(facebook.com)/gm;
  const regexTwitter = /(twitter.com)/gm;
  const regexLinkedIn = /(linkedin.com)/gm;
  const regexYouTube = /(youtube.com)/gm;
  const regexReddit = /(reddit.com)/gm;
  const authors = _createAuthorArray(articleAuthors);

  function _createAuthorArray(authorsArray) {
    let authors = [];
    authorsArray.forEach(function (author) {
      let socials = _createSocialArray(author);
      author["socialArray"] = socials;
      authors.push(author);
    });
    return authors;
  }

  function _createSocialArray(author) {
    let socials = [];

    if (author.social !== undefined) {
      author.social.forEach(function (link) {
        if (link.value) {
          let linkObj = { link: generalUtil._fixOpenLink(link.value) };
          if (link.value.match(regexFaceBook)) {
            linkObj["network"] = "fb";
          } else if (link.value.match(regexTwitter)) {
            linkObj["network"] = "tw";
          } else if (link.value.match(regexLinkedIn)) {
            linkObj["network"] = "li";
          } else if (link.value.match(regexYouTube)) {
            linkObj["network"] = "yt";
          } else if (link.value.match(regexReddit)) {
            linkObj["network"] = "re";
          } else {
            linkObj["network"] = "web";
          }
          socials.push(linkObj);
        }
      });
    }

    return socials;
  }

  const createAuthors = (author = {}) => (
    <>
      <Grid item xs={12} key={author.name}>
        <Box sx={{ mt: 1 }}>
          <Link
            to={author.path}
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <div
              style={{
                width: 164,
                height: 164,
                borderRadius: "50%",
                overflow: "hidden",
              }}
            >
              <img
                src={generalUtil._cleanImages(author.thumbnail.url)}
                style={{
                  objectFit: "cover",
                  width: "100%",
                  height: "100%",
                  cursor: "pointer",
                  marginBottom: 0,
                }}
              />
            </div>
          </Link>
        </Box>
      </Grid>
      <Grid
        container
        item
        xs={8}
        direction="column"
        spacing={0}
        alignItems="center"
        justifyContent="center"
      >
        <Box sx={{ pl: 2, pr: 2 }}>
          <Grid item>
            <Link
              to={author.path}
              style={{
                textDecoration: "none",
                color: "inherit",
                textAlign: "center",
              }}
            >
              <Typography
                variant="h3"
                align="center"
                sx={{ color: "black", fontWeight: 450 }}
              >
                {author.name}
              </Typography>
            </Link>
          </Grid>
  
          <Grid
            container
            item
            xs
            direction="column"
            spacing={0}
            alignItems="center"
            justifyContent="center"
          >
            <Grid item>
              <Typography
                variant="h7title"
                align="center"
                sx={{ display: "block", color: "#68768B" }}
              >
                {author.title}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Grid>
      <Grid
        container
        item
        xs
        direction="row"
        spacing={1}
        sx={{ mb: 1 }}
        alignItems="center"
        justifyContent="center"
      >
        <>{author.socialArray.map(createSocials)}</>
      </Grid>
    </>
  );
  
  const createSocials = (linkObject = {}) => (
    <div key={linkObject.link}>
      <>
        <Grid item>
          <a href={linkObject.link} target="_blank" rel="noopener noreferrer">
            {linkObject.network === "fb" ? (
              <>
                <IconButton aria-label="Facebook" component="label">
                  <FacebookIcon fontSize="small" />
                </IconButton>
              </>
            ) : (
              ""
            )}
            {linkObject.network === "tw" ? (
              <>
                <IconButton aria-label="Twitter" component="label">
                  <TwitterIcon fontSize="small" />
                </IconButton>
              </>
            ) : (
              ""
            )}
            {linkObject.network === "li" ? (
              <>
                <IconButton aria-label="LinkedIn" component="label">
                  <LinkedInIcon fontSize="small" />
                </IconButton>
              </>
            ) : (
              ""
            )}
            {linkObject.network === "yt" ? (
              <>
                <IconButton aria-label="YouTube" component="label">
                  <YouTubeIcon fontSize="small" />
                </IconButton>
              </>
            ) : (
              ""
            )}
            {linkObject.network === "re" ? (
              <>
                <IconButton aria-label="Reddit" component="label">
                  <RedditIcon fontSize="small" />
                </IconButton>
              </>
            ) : (
              ""
            )}
  
            {linkObject.network === "web" ? (
              <>
                <IconButton aria-label="Web" component="label">
                  <WebIcon fontSize="small" />
                </IconButton>
              </>
            ) : (
              ""
            )}
          </a>
        </Grid>
      </>
    </div>
  );

  const baseChildren = <>{authors.map(createAuthors)}</>;

  return (
    <Card sx={{ borderRadius: 5, boxShadow: 1 }}>
      <Grid
        container
        item
        xs
        direction="column"
        spacing={1}
        alignItems="center"
        justifyContent="center"
        sx={{ pt: 3, pb: 3 }}
      >
        {baseChildren.props.children}
      </Grid>
    </Card>
  );
};
export default ArticleAuthorCard;
